import axios from '@/lib/axios';
import type { Challenge } from '@/types/challenges';

export default class BackendService {
  static getClicker = async () => {
    const { data } = await axios.get('me/');
    return data;
  };

  static getAllChallenges = async () => {
    const { data } = await axios.get('challenges/');
    return data;
  };

  static getMeChallenges = async (): Promise<{
    next: string;
    previous: string;
    results: Challenge[];
  }> => {
    const { data } = await axios.get('challenges/?only=me');
    return data;
  };

  static startChallenge = async (
    id: number
  ): Promise<{ reason: string; status: string }> => {
    const { data } = await axios.get(`challenges/${id}/start/`);
    return data;
  };

  static getChallengeById = async (id: number) => {
    const { data } = await axios.get(`challenges/${id}/`);
    return data;
  };

  static getMyChallengeDetails = async (id: number) => {
    const { data } = await axios.get(`challenges/${id}/me/`);
    return data;
  };

  static getChallengeCoinDetails = async (
    challengeId: string,
    coinId: string
  ) => {
    const { data } = await axios.get(
      `challenges/${challengeId}/assets/${coinId.toLowerCase()}/`
    );
    return data;
  };

  static getCoins = async (searchQuery?: string) => {
    const url = searchQuery
      ? `coins/?q=${encodeURIComponent(searchQuery)}`
      : 'coins/';
    const { data } = await axios.get(url);
    return data;
  };

  static buyCoins = async (
    challengeId: string,
    coinSymbol: string,
    amount: number
  ) => {
    const { data } = await axios.post(
      `challenges/${challengeId}/assets/${coinSymbol.toLowerCase()}/buy/`,
      { amount: amount.toString() }
    );
    return data;
  };

  static sellCoins = async (
    challengeId: string,
    coinSymbol: string,
    quantity: number
  ) => {
    const { data } = await axios.post(
      `challenges/${challengeId}/assets/${coinSymbol.toLowerCase()}/sell/`,
      { quantity: quantity.toString() }
    );
    return data;
  };

  static getCandlestickData = async (symbol: string, interval: string) => {
    const { data } = await axios.get(
      `candlestick/${symbol}/?interval=${interval}`
    );
    return data;
  };

  // Leaderboard API methods
  static getLeaderboard = async (start: number = 0, end: number = 99) => {
    const { data } = await axios.get(`leaderboard/?start=${start}&end=${end}`);
    return data;
  };

  static getUserRank = async () => {
    const { data } = await axios.get('leaderboard/my-rank/');
    return data;
  };

  static getLeaderboardStats = async () => {
    const { data } = await axios.get('leaderboard/stats/');
    return data;
  };

  // Challenge-specific Leaderboard API methods
  static getChallengeLeaderboard = async (
    challengeId: number,
    start: number = 0,
    end: number = 99
  ) => {
    const { data } = await axios.get(
      `challenges/${challengeId}/leaderboard/?start=${start}&end=${end}`
    );
    return data;
  };

  static getChallengeUserRank = async (challengeId: number) => {
    const { data } = await axios.get(
      `challenges/${challengeId}/leaderboard/my-rank/`
    );
    return data;
  };

  static getChallengeLeaderboardStats = async (challengeId: number) => {
    const { data } = await axios.get(
      `challenges/${challengeId}/leaderboard/stats/`
    );
    return data;
  };
}
